import { useEffect } from 'react';
import {
    BlindWatermark,
    // Watermark,
    type WatermarkOptions,
} from 'watermark-js-plus';
import Formatter from 'common/utils/formatter';
import { type ICookieUserInfo } from '../../../../types/auth';

interface UseWatermarkOptions {
    userInfo?: ICookieUserInfo;
}

/**
 * 水印 Hook
 * 在页面添加盲水印，显示当前时间和用户邮箱
 * @param options - 配置选项
 */
// https://zhensherlock.github.io/watermark-js-plus/zh/guide/blind-watermark.html 暗水印解密
export const useWatermark = (options: UseWatermarkOptions = {}) => {
    const { userInfo } = options;
    const formatTime = () => {
        const time = Formatter.time.getPlatformValue('YYYY-MM-DD HH:mm');
        const timezone = Formatter.time.timezone;
        const char = timezone < 0 ? '-' : '+';
        return `(GMT${char}${Math.abs(timezone)}) ${time}`;
    };

    const generateContent = () => {
        return [userInfo.uuid, userInfo.firstname, userInfo.lastname, formatTime()].join(' ');
    };
    useEffect(() => {
        const commonOptions: Partial<WatermarkOptions> = {
            contentType: 'multi-line-text',
            fontSize: '16px',
            content: generateContent(),
            width: 200,
            height: 200,
        };

        const watermark = new BlindWatermark(commonOptions);
        // const watermark = new Watermark(commonOptions);
        void watermark.create();

        // 每秒更新时间
        const timer = setInterval(() => {
            void watermark.changeOptions({
                ...commonOptions,
                content: generateContent(),
            });
        }, 60 * 1000);

        return () => {
            clearInterval(timer);
            watermark.destroy();
        };
    }, [userInfo?.uuid]);
};
